import apiBase from "./apiBase";

class ExternalOfferApi {
  static getExternalOfferList(pageNumber, pageSize, sortBy) {
    const payload = {
      paging: {
        pageNumber,
        pageSize,
      },
      sortBy: Object.assign({}, ...sortBy.map((x) => ({[x.id]: x.value}))),
    };
    return apiBase.create().post(`/externalOffer/list`, payload);
  }

  static create(data) {
    return apiBase.create().post('/externalOffer/create', data);
  }

  static update(id, data) {
    return apiBase.create().put(`/externalOffer/${id}`, data);
  }

  static delete(id) {
    return apiBase.create().delete(`/externalOffer/${id}`);
  }
}

export default ExternalOfferApi;
